import { EnvValue } from 'app/services/env.service/EnvValue.type';

export function getEnvFormConfigVersion(
  valueFromEnv: EnvValue
): string | undefined {
  const trimmedValue = valueFromEnv?.trim();

  if (!trimmedValue) {
    return undefined;
  }

  if (!/^\d+$/.test(trimmedValue)) {
    console.warn(
      `Invalid form-config version "${trimmedValue}". Falling back to current.`
    );
    return undefined;
  }

  return trimmedValue;
}
